import { ThunkAction } from '@reduxjs/toolkit';
import { store } from 'app/store';
import { useDispatch, useSelector } from 'react-redux';

export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useAppSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export type ThunkType<ExtraArguments> = ThunkAction<void, RootState, ExtraArguments, any>;
